import { DataGridColSettings } from '@/components/DataGrid/utils';

export const arrestsToolDataGridCols: DataGridColSettings[] = [
  {
    field: 'arrestId',
    headerName: 'Arrest ID',
    width: 140,
    visible: true,
  },
  {
    field: 'arresteeName',
    headerName: 'Arrestee name',
    visible: true,
  },
  {
    field: 'arrestDate',
    headerName: 'Arrest date',
    width: 120,
    visible: true,
  },
  {
    field: 'arrestingOfficerName',
    headerName: 'Arresting officer',
    width: 180,
    visible: true,
  },
  {
    field: 'dataWorksStatus',
    headerName: 'DataWorks status',
    width: 180,
    visible: true,
  },
  {
    field: 'arrestType',
    headerName: 'Arrest type',
    width: 200,
    visible: true,
  },
  {
    field: 'arresteeStatus',
    headerName: 'Arrestee status',
    width: 180,
    visible: true,
  },
  {
    field: 'caseId',
    headerName: 'Case ID',
    width: 160,
    visible: true,
  },
  {
    field: 'arrestStatus',
    headerName: 'Arrest status',
    width: 110,
    visible: true,
  },
  {
    field: 'actions',
    headerName: 'Actions',
    width: 180,
    visible: true,
  },
];
